import { z } from "zod";

export const zAttrFinancialView = z.object({
  view: z.literal("FinancialView"),
  labelAttr: z.string(),
  signLocation: z.string(),
});
export type ZAttrFinancialView = z.infer<typeof zAttrFinancialView>;
